import { render } from "./MAPardotForm.vue?vue&type=template&id=b0a0f454"
import script from "./MAPardotForm.vue?vue&type=script&lang=ts"
export * from "./MAPardotForm.vue?vue&type=script&lang=ts"

import "./MAPardotForm.vue?vue&type=style&index=0&id=b0a0f454&lang=scss"
script.render = render

export default script